import React from "react";

import ReactAnimatedWeather from "react-animated-weather";
export default function WeatherIcon(props) {
const codeNigDay={
"01d":"CLEAR_DAY",
"01n":"CLEAR_NIGHT",
"02d":"PARTLY_CLOUDY_DAY",
"02n":"PARTLY_CLOUDY_NIGHT",
"03d":"PARTLY_CLOUDY_NIGHT",
"03n":"PARTLY_CLOUDY_NIGHT",
"04d":"CLOUDY",
"04n":"CLOUDY",
"09d":"RAIN",
"09n":"RAIN",
"10d":"SLEET",
"10n":"SLEET",
"11d":"SNOW",
"11n":"SNOW",
"13d":"WIND",
"13n":"WIND",
"50d":"FOG",
"50n":"FOG"
};
return(
  <ReactAnimatedWeather
    icon={codeNigDay[props.code]}
    color="#a52a2a"
    size={64}
    animate={true}
  />);
};
